import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

const PATH_INVALID_MESSAGE =
  'The page route must be a valid URL path ([a-z0-9-/]+) and must not start with a dot.';
const ROUTE_EXISTS_MESSAGE =
  'The page route must be unique, please choose a route that has not been used yet in your application.';

export function createDashboardRouteValidation(projectFolder: string) {
  return composeValidations([
    [pathAvailableValidation(projectFolder), ROUTE_EXISTS_MESSAGE],
    [pathValidation, PATH_INVALID_MESSAGE],
  ]);
}
